var render = function render(){var _vm=this,_c=_vm._self._c;return _c('auto-complete-master-data-select',{attrs:{"display-type":"idOnly","label":_vm.label,"prepared-options":_vm.getDriverGroupOptionsForUser,"init-value-id":_vm.value,"watch-value-id":_vm.selectedValue,"on-item-changed":_vm.handleDriverGroupSelected}})
}
var staticRenderFns = []

export { render, staticRenderFns }